import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import { fontFamily } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

import { Box } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label, Span } from '../../../typography';
import { ErrorMessage } from 'formik';

const TimePickerWrapper = styled.div<StyledSystemProps>`
  width: 100%;
  .react-date-picker,
  .react-daterange-picker {
    background-color: #fff;
    height: 40px;
    display: flex;
    font-weight: 400;
    border-radius: 4px;
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
  }
  .react-date-picker > .react-date-picker__wrapper,
  .react-daterange-picker > .react-daterange-picker__wrapper {
    border-radius: 4px;
    border: 1px solid rgba(50, 50, 93, 0.2);
  }
  .react-calendar {
    border: 1px solid rgba(50, 50, 93, 0.2);
    border-radius: 4px;
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
    ${fontFamily};
    padding: 10px;
  }
  .react-datepicker__input-container input {
    background-color: #fff;
    height: 38px;
    width: 90%;
    display: block;
    font-weight: 400;
    border-radius: 4px;
    color: ${themeGet('colors.primary', '#222429')};
    font-size: ${themeGet('fontSize[1]', '16px')};
    border-radius: 4px;
    border: 1px solid rgba(50, 50, 93, 0.2);
    padding-left: 10px;
  }

  .react-datepicker__time-list {
    height: 100px;
    overflow-y: scroll;
    width: 150%;
    overflow-x: hidden;
    display: block;
  }

  .react-datepicker__time-box {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin-top: -10px;
    width: 200%;
    z-index: 1;
  }

  .react-datepicker__time-list-item {
    list-style: none;
    padding: 10px;
    margin-left: -40px;
    width: 120%;
    background-color: #fff;
  }

  .react-datepicker-time__header {
    display: none;
  }
  .react-datepicker__aria-live {
    display: none;
  }
  /* Elevate only the open popup above sibling fields — not the whole field box,
     which would otherwise permanently sit above unrelated dropdowns nearby. */
  .react-datepicker-popper {
    z-index: 100;
  }
`;

const StyledFormTimePicker = ({
  date,
  dateLabel,
  endDate,
  endDateId,
  endDateLabel,
  maxDate,
  minDate,
  readOnly,
  disabled,
  showLeadingZeros,
  startDate,
  startDateId,
  startDateLabel,
  form: { setFieldValue },
  label,
  changeHandler,
  format,
  name,
  clearIcon,
  zIndex,
  ...rest
}: any) => {
  return (
    <Box {...rest}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <TimePickerWrapper>
        <DatePicker
          selected={date ?? null}
          onChange={(date: any) => {
            setFieldValue(dateLabel, date);
            if (changeHandler) changeHandler(date);
          }}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="Time"
          dateFormat="h:mm aa"
          timeFormat="HH:mm"
          placeholderText="Select time"
          readOnly={readOnly}
          disabled={disabled}
        />
      </TimePickerWrapper>

      <ErrorMessage name={dateLabel}>
        {msg => (
          <Span mt={2} color="red" textAlign="right">
            {msg}
          </Span>
        )}
      </ErrorMessage>
    </Box>
  );
};

StyledFormTimePicker.defaultProps = {
  mb: 4,
  flex: 1,
  minWidth: '150px',
};

export default StyledFormTimePicker;
